/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { MatrixDependencies } from './dependenciesMatrixClass.generated';
import { SparseMatrixDependencies } from './dependenciesSparseMatrixClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMatrix } from '../../factoriesAny.js';
export var matrixDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  MatrixDependencies: MatrixDependencies,
  SparseMatrixDependencies: SparseMatrixDependencies,
  typedDependencies: typedDependencies,
  createMatrix: createMatrix
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMatrix.generated.js
// module id = 11
// module chunks = 0